<ng-template #modalConfirmNavigation let-c="close" let-d="dismiss">
  <wsb-modal
    cancelButtonEnable="true"
    cancelButtonText="{{ 'common_cancel' | translate }}"
    primaryButtonText="{{ 'common_ok' | translate }}"
    (primary)="goToEditor()"
    (dismiss)="d()"
  >
    <div body>
      <div translate>mail_go_back_to_editor</div>
    </div>
  </wsb-modal>
</ng-template>

<h1 class="page__title my-5 h2">{{ 'common_recipient' | translate }}</h1>
<div class="my-5">
  <div ngbDropdown class="d-flex flex-column dropdown_small_device custom">
    <button class="btn btn-primary" id="dropdownAccountTab" #dropdown ngbDropdownToggle translate>mail_recipients</button>
    <div ngbDropdownMenu aria-labelledby="dropdownAccountTab">
      <button ngbDropdownItem translate (click)="nav.select(1); dropdown.innerText = $event.target.innerText">
        mail_group_group
      </button>
      <button ngbDropdownItem translate (click)="nav.select(2); dropdown.innerText = $event.target.innerText">
        mail_group_users
      </button>
    </div>
  </div>
  <ul ngbNav #nav="ngbNav" class="nav-tabs nav_tab_large_device custom" [(activeId)]="activeId">
    <li [ngbNavItem]="1">
      <a ngbNavLink translate>mail_group_group</a>
      <ng-template ngbNavContent>
          <wsb-contacts-groups class="groups-list" #groupListComponent [page]="'mail'"> </wsb-contacts-groups>
      </ng-template>
    </li>
    <li [ngbNavItem]="2">
      <a ngbNavLink translate>mail_group_users</a>
      <ng-template ngbNavContent>
        <wsb-contacts-list class="contacts-list" #contactsListComponent [page]="'mail'"> </wsb-contacts-list>
      </ng-template>
    </li>
  </ul>
</div>
<div [ngbNavOutlet]="nav" class="mt-2"></div>
